export enum VehicleType {
  'V' = 'osobowy',
  'L' = 'ciężarowy'
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/dictonaries/vehicle-type.enum.ts